'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EmailUnarchiveMultiModal({
  onCancel,
  onUnarchive,
  selected
}) {
  const {
    size: count
  } = selected;
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "unarchive-multi-modal",
    width: 500,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.modals.unarchiveMulti.header",
          options: {
            count
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.modals.unarchiveMulti.body",
          options: {
            count
          }
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onUnarchive,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.modals.unarchiveMulti.unarchive"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.modals.unarchiveMulti.cancel"
        })
      })]
    })]
  });
}
EmailUnarchiveMultiModal.propTypes = {
  onCancel: PropTypes.func,
  onUnarchive: PropTypes.func,
  selected: PropTypes.object
};
export default EmailUnarchiveMultiModal;